<template>
  <div class="stats-widget">
    <div class="stats-grid">
      <div class="stat-item" v-for="(item, index) in stats" :key="index">
        <span class="stat-value">{{ item.value }}</span>
        <span class="stat-label">{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatsWidget',
  data() {
    return {
      stats: [
        { label: '今日使用', value: 0 },
        { label: '总使用', value: 0 },
        { label: '剩余次数', value: 0 }
      ]
    }
  },
  created() {
    this.$ajax.get('api/v1/users/me').then(res => {
      if (res.data) {
        this.stats[2].value = res.data.balance || 0
      }
    })
  }
}
</script>

<style scoped>
.stats-widget {
  padding: 4px 0;
}

.stats-grid {
  display: flex;
  justify-content: space-around;
}

.stat-item {
  text-align: center;
}

.stat-value {
  display: block;
  font-size: 24px;
  font-weight: 700;
  color: #1a1a2e;
}

.stat-label {
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/User2/widgets/StatsWidget.vue